/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import styles from "./FeatureOfficeBanner.module.scss";
import questionMark from "images/questionMark.svg";
import { externalRedirect } from "utils/externalRedirect";
import * as paths from "features/routing/paths";
import { Office } from "types/office";

interface FeatureOfficeProps {
  featureOffice: Office | null;
  isMobile?: boolean;
}

export const FeatureOffice: React.FC<FeatureOfficeProps> = ({
  featureOffice,
  isMobile,
}) => {
  if (isMobile)
    return (
      <div className={styles.bannerCard}>
        <div className={styles.bannerMobLeft}>
          <img
            className={styles.questMark}
            src={questionMark}
            alt="question mark"
          />
        </div>
        <div>
          <b>Need to get in sooner?</b> Our {featureOffice?.promoDisplayName}{" "}
          office has appointments available this week.
          <br />
          <a
            href="#"
            onClick={(e) => {
              externalRedirect(
                window.location.origin +
                  paths.appointmentBookingStartV2({
                    officeId: featureOffice?.id,
                  })
              );
              e.preventDefault();
            }}
          >
            See exam times &#10145;
          </a>
        </div>
      </div>
    );

  return (
    <div className={styles.bannerCard}>
      <div className={styles.bannerLeft}>
        <img
          className={styles.questMark}
          src={questionMark}
          alt="question mark"
        />
        <b>Need to get in sooner?</b> Our {featureOffice?.promoDisplayName}{" "}
        office has appointments available this week.
      </div>
      <div className={styles.bannerRight}>
        <a
          href="#"
          onClick={(e) => {
            externalRedirect(
              window.location.origin +
                paths.appointmentBookingStartV2({
                  officeId: featureOffice?.id,
                })
            );
            e.preventDefault();
          }}
        >
          See exam times &#10145;
        </a>
      </div>
    </div>
  );
};
